import * as t from "io-ts"
import { maybe, Maybe } from "@flockcover/flock-svc-core-types"
import { Modify } from "@shared/utils/helpers/modifyType"

export const AddressType = t.type({
  line1: t.string,
  line2: maybe(t.string),
  locality: maybe(t.string),
  region: maybe(t.string),
  postcode: t.string,
  country: t.string,
})

export type Address = t.TypeOf<typeof AddressType>

export type AddressUnsantized = Modify<
  Address,
  {
    line2?: Maybe<string>
    locality?: Maybe<string>
    region?: Maybe<string>
  }
>

export const santizeAddress = (address: AddressUnsantized): Address => ({
  ...address,
  line2: address.line2 || null,
  locality: address.locality || null,
  region: address.region || null,
})
